
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m12.0262 3c3.0768 0 5.5799 2.37913 5.5799 5.30362 0 1.98278-1.1476 3.71718-2.8158 4.60978 3.3895 1.0409 5.8926 3.8663 6.2053 7.3854.1042.8919-1.6689.9418-1.7207.0991-.3653-3.5191-3.5462-6.1955-7.2486-6.1955-3.7549 0-6.88338 2.6764-7.24871 6.1955-.10426.8427-1.87743.7928-1.77317-.0991.36528-3.4698 2.8682-6.3445 6.20528-7.3854-1.6689-.8918-2.81576-2.6272-2.81576-4.60978 0-2.92449 2.55548-5.30362 5.63226-5.30362zm0 1.68538c-2.13769 0-3.85914 1.63548-3.85914 3.61809 0 2.03193 1.72065 3.66813 3.85914 3.66813 2.086 0 3.8065-1.6355 3.8065-3.66813 0-1.98276-1.7206-3.61809-3.8065-3.61809z","fill":"#4a3428"}})])
          )
        }
      }
    